import restClient from 'Shared/hooks/restClient'
import Loading from 'Shared/components/Loading'
import SubscriptionList from 'Shared/components/SubscriptionList'

export default function TargetPreferences({ }) {
  const [loading, setLoading] = useState(true)
  const [preferences, setPreferences] = useState(null)

  useEffect(() => {
    restClient
      .get(`/api/target/subscriptions`)
      .then((r) => {
        setPreferences(r.data)
        setLoading(false)
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <Loading />
  }

  const updateEndpoint = `/api/target/subscriptions/update`

  return (
    <div>
      <h1>Subscription Preferences</h1>
      <SubscriptionsByOrganisation organisations={preferences.subscriptionStatuses} updateEndpoint={updateEndpoint} />
    </div>
  )
}

function SubscriptionsByOrganisation({ organisations, updateEndpoint, fontSizes = 'large' }) {
  if (!organisations || organisations.length === 0) return <p>No subscriptions available.</p>

  const multipleOrganisations = organisations.length > 1
  const sortedOrganisations = _.sortBy(organisations, (org) => {
    return org.organisationName === 'National' ? 0 : 1
  })
  const [expandedIds, setExpandedIds] = useState([sortedOrganisations[0].organisationTargetId])

  function toggleExpand(organisationTargetId) {
    const isExpanded = _.includes(expandedIds, organisationTargetId)
    const newExpandedIds = isExpanded
      ? _.without(expandedIds, organisationTargetId)
      : [...expandedIds, organisationTargetId]
    setExpandedIds(newExpandedIds)
  }

  return <div>
    {sortedOrganisations.map(({ organisationName, subscriptions, organisationTargetId }, index) => {
      const isExpanded = _.includes(expandedIds, organisationTargetId)
      const chevronIcon = isExpanded ? '▼' : '►'

      const HeaderTag = fontSizes === 'small' ? 'p' : 'h2'
      const headerProps = {
        className: fontSizes === 'small' ? 'bold' : undefined,
        style: {
          cursor: 'pointer',
          ...(fontSizes === 'large' && { fontSize: '1.5em' })
        },
        onClick: () => toggleExpand(organisationTargetId)
      }

      return <div className='margin-bottom double' style={{ maxWidth: '600px' }} key={organisationTargetId}>
        {multipleOrganisations && React.createElement(HeaderTag, headerProps,
          <span style={{ fontSize: '0.75em' }}>{chevronIcon}</span>, ' ', organisationName
        )}
        {isExpanded && <SubscriptionList {...{ subscriptions, fontSizes, organisationTargetId, updateEndpoint, expanded: index === 0 }} />}
      </div>
    })}
  </div>
}

export { SubscriptionsByOrganisation }
